import { render } from "./LegendMenu.vue?vue&type=template&id=f7430ad4"
import script from "./LegendMenu.vue?vue&type=script&lang=js"
export * from "./LegendMenu.vue?vue&type=script&lang=js"

import "./LegendMenu.vue?vue&type=style&index=0&id=f7430ad4&lang=sass"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__